import React, { useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import { MenuComponent } from '../../../../_template/assets/ts/components/MenuComponent';
import { ToggleComponent } from '../../../../_template/assets/ts/components/ToggleComponent';

import Pagination from '../../../component/common/pagination/Pagination';
import NoDataFound from '../../../component/common/NoDataFound';
import BotList from './BotList';
import { PageTitle } from '../../../../_template/layout/core/PageData';
import DashboardInfoCard from '../../../component/DashboardInfoCard';

const Dashboard = () => {
    const api_base_url = process.env.REACT_APP_API_URL;

    const pageTitle = [
        {
            title: 'Dashboard',
            path: 'dashboard',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const [loading, setLoading] = useState(false);
    const [businessData, setBusinessData] = useState([]);

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
            ToggleComponent.reinitialization()
        }, 500);
    })

    useEffect(()=>{
        getAllBusiness();
    },[])
    
    const getAllBusiness = async () => {
        setLoading(true);
        try {
            var api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('systemAdminToken')
                }
            };
            await axios.post(`${api_base_url}business/get-business-details`, {}, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setBusinessData(res.data.data.businessData);
                    setLoading(false);
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error) {
            //setDone(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.body.setAttribute('data-sai-app-sidebar-hoverable', 'flase')
        document.body.setAttribute('data-sai-app-sidebar-push-header', 'false')
        document.body.setAttribute('data-sai-app-sidebar-push-toolbar', 'false')
        document.body.setAttribute('data-sai-app-sidebar-enabled', 'false')
        document.body.setAttribute('data-sai-app-sidebar-fixed', 'false')
        document.body.setAttribute('data-sai-app-toolbar-enabled', 'false')
    }, [])
    
    return (
        <div className="row">
            { businessData.map((item, index) => (
                <DashboardInfoCard items={item} key={index} />
            ))}
        </div>
    )
}

export default Dashboard